import React from "react";
import FileUpload from "../../Common/FileUpload";

const SmoothieImgUpload = (props: { values: any; setFieldValue: any,jobId:any }) => {
  const { values, setFieldValue,jobId } = props;

  return (
    <FileUpload
    jobId={jobId}
      values={values}
      setFieldValue={setFieldValue}
      fieldName="smoothieSetupMedia"
      label="Add pictures of smoothie setup (attachments)"
    />
  );
};

export default SmoothieImgUpload;